import { WebInterfaceBaseState } from '../../../../../../../common/base/state';
import { connect } from 'react-redux';
import ObjectSelectPopover from '../components';
import { IObjectSelectPopoverProps } from '../entities/IObjectSelectPopoverProps';
import { openObjectSelectAction, closeObjectSelectAction } from '../actions';
import { getObjectList } from '../selectors/getObjectListSelector';
import { getPopoverLoading } from '../../objectSelectPopover/selectors/getPopoverLoadingSelector';
import { getCurrentFolder } from '../../objectSelectPopover/selectors/getCurrentFolderSelector';
import { getLoadingMore } from '../../objectSelectPopover/selectors/getLoadingMoreSelector';
import { IObjectSelectActionPayload } from '../entities/IObjectSelectActionPayload';
import { onActionReceivedTransaction } from '../actions/onActionReceivedTransaction';
import { loadMoreFoldersAction } from '../actions/loadMoreFoldersAction';
import { IObjectSelectLoadMorePayload } from '../entities/IObjectSelectLoadMorePayload';
import IObjectSelectSearchPayload from '../entities/IObjectSelectSearchPayload';
import selectPopoverSearchAction from '../actions/selectPopoverSearchAction';
import { updateLoadingAction } from '../actions/updateLoadingAction';

const mapStateToProps = function (
	state: WebInterfaceBaseState,
	props: IObjectSelectPopoverProps
): IObjectSelectPopoverProps {
	return {
		isLoading: getPopoverLoading(state),
		objectList: getObjectList(state),
		currentFolder: getCurrentFolder(state),
		isLoadingMore: getLoadingMore(state)
	};
};

const mapDispatchToProps = function (dispatch: Function): IObjectSelectPopoverProps {
	return {
		notifyClose: () => {
			dispatch(closeObjectSelectAction());
		},
		notifyOpen: (data: any) => {
			dispatch(openObjectSelectAction(data));
		},
		onActionReceived: (data: IObjectSelectActionPayload) => {
			dispatch(onActionReceivedTransaction(data));
		},
		loadMoreFolders: (data: IObjectSelectLoadMorePayload) => {
			dispatch(loadMoreFoldersAction(data));
		},
		onSearch: (data: IObjectSelectSearchPayload) => {
			dispatch(selectPopoverSearchAction(data));
		},
		changeLoading: (loading: boolean) => {
			dispatch(updateLoadingAction(loading));
		}
	};
};

export const ObjectSelectPopoverContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ObjectSelectPopover);
